import { render, staticRenderFns } from "./ProjectBrowser.vue?vue&type=template&id=4d2b3e2c&scoped=true"
import script from "./ProjectBrowser.vue?vue&type=script&lang=js"
export * from "./ProjectBrowser.vue?vue&type=script&lang=js"
import style0 from "./ProjectBrowser.vue?vue&type=style&index=0&id=4d2b3e2c&prod&scoped=true&lang=css"
import style1 from "./ProjectBrowser.vue?vue&type=style&index=1&id=4d2b3e2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2b3e2c",
  null
  
)

export default component.exports